/**
 * 车险管理-保单列表
 */

export default {
    name: 'AutoInsurancePolicyList',
    path: '/AutoInsurancePolicyList',
    component: () => import('@/views/vehicleInsurancePolicyList/'),
    redirect: { name: 'AutoInsurancePolicyListIndex' },
    meta: {
        title: '保单列表',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: 'AutoInsurancePolicyListIndex',
            path: 'index',
            component: () => import('@/views/vehicleInsurancePolicyList/home/Home.vue'),
        },
        {
            name: 'AutoInsurancePolicyListDetail',
            path: 'read',
            component: () => import('@/views/vehicleInsurancePolicyList/detail/Detail.vue'),
        },
    ],
};
